var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setActiveTab as setActiveTabAction } from '../../../actions/creators/sidebar';
import { clearLive as clearLiveAction } from '../../../actions/creators/live';
import { setDisplayMode as setDisplayModeAction } from '../../../actions/creators/displayMode';
import LivePage from './LivePage';
import Event from '../event/EventLive';
import Timetable from './timetable/Timetable';
var Live = /** @class */ (function (_super) {
    __extends(Live, _super);
    function Live() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Live.prototype.componentDidMount = function () {
        if (localStorage.getItem('displayMode') !== undefined && localStorage.getItem('displayMode') !== null) {
            this.props.setDisplayModeAction({ type: 2, id: +localStorage.getItem('displayMode') });
        }
        this.props.setActiveTabAction('live');
    };
    Live.prototype.componentWillUnmount = function () {
        // this.props.clearLiveAction();
        this.props.setDisplayModeAction({ type: 1 });
    };
    Live.prototype.render = function () {
        var _a = this.props, match = _a.match, section = _a.section, gridLocalization = _a.gridLocalization;
        var params = match.params;
        var props = {
            section: section,
            gridLocalization: gridLocalization
        };
        if (params.eventId) {
            return (_jsx(Event, __assign({ eventId: +params.eventId }, props)));
        }
        if (match.path === '/timetable') {
            return (_jsx(Timetable, {}));
        }
        return (_jsx(React.Fragment, { children: _jsx(LivePage, __assign({}, props)) }));
    };
    return Live;
}(React.Component));
Live.propTypes = {
    section: PropTypes.string.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    setActiveTabAction: PropTypes.func.isRequired,
    setDisplayModeAction: PropTypes.func.isRequired,
    clearLiveAction: PropTypes.func.isRequired,
};
var mapStateToProps = function (state) { return ({
    routing: state.routing
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    setActiveTabAction: setActiveTabAction,
    setDisplayModeAction: setDisplayModeAction,
    clearLiveAction: clearLiveAction
}, dispatch); };
Live = connect(mapStateToProps, mapDispatchToProps)(Live);
export default Live;



// WEBPACK FOOTER //
// ./src/components/grid/live/index.js